import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetDeptsAllSuspense } from '@/context/services/dept/Dept.service';
import { Dept } from 'ap-openapi';

export const useFindDepts = () => {
  const items = useGetDeptsAllSuspense();
  const findById = useFindById<Dept, 'id', 'display_name'>(items, {
    key: 'id',
    return: 'display_name',
    defaultVal: '',
  });
  const findByName = useFindByName<Dept, 'display_name', 'id'>(items, {
    key: 'display_name',
    return: 'id',
    defaultVal: '',
  });
  return {
    findDeptById: findById,
    findDeptByName: findByName,
  };
};
